import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

const mime = require('mime-types')

class FileViewDownload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageData: props.imageData,
            mimeType: mime.lookup(props.fileMime),
            fileMime: props.fileMime,
            width: 600,
            height: 800,
        };
    }

    downloadFile = () => {
        var a = document.createElement("a"); //Create <a>
        a.href = "data:application/octet-stream;base64," + this.state.ImageBase64; //Image Base64 Goes here
        a.download = this.state.fileMime.split('/')[this.state.fileMime.split('/').length - 1]; //File name Here
        a.click()
        this.props.cancelPic()
    }

    render() {
        return (
            <div className='cameraModal'>
                <div className="fileDisplayDiv" style={{ width: this.state.width}}>
                    <div className='fileInnerDiv' style={{ width: this.state.width, height: '100%', overflowY: "auto" }}>
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "flex-start", marginTop: '58px' }}>
                            <div className="VideoAndCanvas">
                                {this.state.mimeType.includes('image') 
                                    ? <img src={`data:${this.state.mimeType};base64,${this.state.imageData}`} width={this.state.width} alt="NewIamge" style={{ objectFit: 'contain' }} />
                                    : <div style={{paddingTop: '17vh', height: '86vh'}}><iframe src={`data:${this.state.mimeType};base64,${this.state.imageData}`} width={this.state.width} title="NewIamge" style={{ height: '100%' }} /></div>
                                }
                            </div>
                            <div className='cameraCaptureButtons' style={{ width: this.state.width * .5 }}>
                                <Button variant="contained" color="primary" className="ButtonShadow" onClick={() => this.downloadFile()}>Download</Button>
                                <Button variant="contained" color="secondary" className="ButtonShadow" onClick={() => this.props.cancelPic()}>Close</Button>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FileViewDownload;


// WEBPACK FOOTER //
// ./src/components/FileViewDownload.js